import React, { useState, useCallback } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Status from "../Status";
import { Label } from "../";

import {
  addCommaToEvery3Digits,
  changeVehicleWeight,
  convertDate, convertOption,
} from "../../lib";

const useStyles = makeStyles(() => ({
  pagination: {
    flexShrink: 0,
  },
}));

export default function Content(props: any) {
  const classes = useStyles();
  const { settlements } = props;
  console.log(settlements);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleChangePage = useCallback(
    (e, newPage) => {
      setPage(newPage);
    },
    [setPage]
  );

  const handleChangeRowsPerPage = useCallback(
    (e) => {
      setRowsPerPage(e.target.value);
      setPage(0);
    },
    [setRowsPerPage]
  );

  return (
    <div>
      <Table size="medium">
        <TableHead>
          <TableRow>
            <TableCell>
              <Label>{"운송번호|상태"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"날짜/시간"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"장소명"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"차량정보|기본단가"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"청구금액"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"옵션"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"비고"}</Label>
            </TableCell>
            <TableCell>
              <Label>{"정산 전달사항"}</Label>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {settlements &&
            settlements
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((s: any, i: number) => (
                <TableRow key={i}>
                  <TableCell>
                    {s.no}
                    <br />
                    <Status status={s.status} />
                  </TableCell>
                  <TableCell>
                    {convertDate(new Date(s.departureDate))}
                    {s.waypoints &&
                      s.waypoints.map((v: any, i: number) => {
                        return (
                          <>
                            <br />
                            {convertDate(new Date(v.date))}
                          </>
                        );
                      })}
                    <br />
                    {convertDate(new Date(s.arrivalDate))}
                  </TableCell>
                  <TableCell>
                    {s.departureName}
                    {s.waypoints &&
                      s.waypoints.map((v: any, i: number) => {
                        return (
                          <>
                            <br />
                            {v.name}
                          </>
                        );
                      })}
                    <br />
                    {s.arrivalName}
                  </TableCell>
                  <TableCell>
                    {s.vehicleType +
                      " / " +
                      changeVehicleWeight(s.vehicleType, s.vehicleWeight)}
                    <br />
                    {addCommaToEvery3Digits(s.chargeUnit)}원
                  </TableCell>
                  <TableCell>
                    {addCommaToEvery3Digits(s.chargeTotal)}원
                  </TableCell>
                  <TableCell>{convertOption(s.optionBackDoorOpen, s.optionForklift, s.optionShuttle, false, 1, 0, false, s.optionCashOnDelivery)}</TableCell>
                  <TableCell>{s.memoForCustomer}</TableCell>
                  <TableCell>{s.settlementMemoForCustomer}</TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={settlements.length} // 전체 row 갯수
        page={page} // zero-based index of the current page
        rowsPerPage={rowsPerPage} // number of rows per page
        rowsPerPageOptions={[10, 20, 50]} // rows per page select field
        onPageChange={handleChangePage} // Callback fired when the page is changed
        onRowsPerPageChange={handleChangeRowsPerPage} // Callback fired when the number of rows per page is changed
        className={classes.pagination}
      />
    </div>
  );
}
